import { Button, Text, VStack } from 'ui_2';

export const ErrorMessage = ({
  errorMessage,
  reset,
  goHome,
}: {
  errorMessage: string;
  reset: () => void;
  goHome?: () => void;
}) => {
  return (
    <VStack className='flex min-h-[100dvh] items-center justify-center '>
      <VStack className='max-w-[80%] items-center gap-2 rounded-[10px] border border-[#F08C8C] bg-[#E61E1E40] p-4 text-center'>
        <Text color='mysteryCityRed' family='space'>
          There was an error loading your game
        </Text>
        <Text color='mysteryCityRed' family='space'>
          {errorMessage}
        </Text>
        <Button
          variant='mysteryCityError'
          className='w-4/5'
          onClick={() => window.location.reload()}
        >
          Try again
        </Button>
        {goHome && (
          <Button
            variant='mysteryCitySecondary'
            className='w-4/5'
            onClick={() => goHome()}
          >
            Go home
          </Button>
        )}
      </VStack>
    </VStack>
  );
};
